export default "__VITE_ASSET__c011f8ce__"